const SECRETS = {
    REACT_APP_API_BASE: 'https://tatva-ai-backend.mytatva.in/',
    REACT_APP_WEBSOCKET_BASE: 'wss://tatva-ai-backend.mytatva.in/',
    REACT_APP_MO_ENGAGE_APP_ID: 'TC5B48PR9UEHLG70GXX63D8S',
    REACT_APP_MO_ENGAGE_DATA_CENTER: 'DC_3',
    REACT_APP_MO_ENGAGE_ENABLE_DEBUG_LOGS: 0,
    REACT_APP_BHASHINI_USERID: 'e1ff22534d5945c19a355f6c022e2445',
    REACT_APP_BHASHINI_ULCA_APIKEY: '243807eea8-5069-4f7b-9761-04ac7b5ff4ed',
    REACT_APP_BHASHINI_APIKEY: 'FlynKLesr2L_kwYqAXuPoAg7HuwQWJXhOGnGKHeFTqXDAqm7-mby3kLz9zmVZGCw',
};

export default SECRETS;